module.exports = __webpack_public_path__ + "img/drawer_robot.901b7f20.svg";